import Loader from './services/loader';
import LazyLoad from './services/lazyload';
import Utils from './services/utils';
import Nav from './components/nav';
import Landing from './components/landing';
import Accordions from './services/accordions';
import Gallery from './components/gallery';
import Category from './components/category';
import BoilerPlate from './components/boiler-plate';
import Request from './components/request';
import Newsletter from './components/newsletter';

import 'lazysizes'
import 'lazysizes/plugins/parent-fit/ls.parent-fit';
import 'lazysizes/plugins/unveilhooks/ls.unveilhooks';

let load = true;

const App = {
    init: async () => {
        if (load) {
            await App.sizeSet();
            await Loader.init();
            await LazyLoad.init();
            await Nav.init();
            await Landing.init();
            await Accordions.init();
            await Gallery.init();
            await Category.init();
            await BoilerPlate.init();
            await Request.init();
            await Newsletter.init();
            load = false;
        }
    },
    sizeSet: () => {
        App.width = (window.innerWidth || document.documentElement.clientWidth);
        App.height = (window.innerHeight || document.documentElement.clientHeight);
        if (App.width <= 768)
            App.isMobile = true;
        if (App.isMobile) {
            if (App.width > 768) {
                App.isMobile = false;
            }
        }
    }
};

export default App;

document.addEventListener("DOMContentLoaded", () => {
    App.init();
    window.addEventListener('resize', App.sizeSet);

});